export default "/build/static/fonts/Whitney-Light_Web.woff";